import {useQuery} from '@github-ui/react-query'
import {PanelList} from '@github-ui/panel-list'
import type {RuleConfig} from './types'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {RuleRow} from './components/rule-row'

async function fetchRuleConfigs({path, refName}: {path: string; refName: string}) {
  const response = await verifiedFetchJSON(`${path}?ref=${encodeURIComponent(refName)}`)
  if (response.ok) {
    return response.json()
  }
  throw new Error('Failed to fetch rule configurations')
}

export type RuleListProps = {
  refName: string
  path: string
}
export function RuleConfigList({refName, path}: RuleListProps) {
  const {data: ruleConfigs} = useQuery<RuleConfig[]>({
    queryKey: [path, refName],
    queryFn: () => fetchRuleConfigs({path, refName}),
  })

  if (!ruleConfigs) {
    return null
  }

  return (
    <>
      <PanelList isEmpty={ruleConfigs.length === 0}>
        <PanelList.BoxHeader title="Rules" />
        <PanelList.Rows>
          {ruleConfigs.map(config => (
            <RuleRow key={config.type} ruleConfig={config} />
          ))}
        </PanelList.Rows>
      </PanelList>
    </>
  )
}
